<template>
  <Modal v-model="visible" width="500px" :footer-hide="true" :mask-closable="false" class="my-modal top">
    <!-- <img src="@static/images/success.png" alt=""> -->
    <div class="title-text">文件已上传成功，正在转化为电子合同</div>
    <div class="info-text">合同状态变为可制作时，可点击【制作合同】为合同添加变量和签署区</div>
    <div class="info-text-desc">若合同状态未自动更新，可手动点击刷新按钮</div>
    <div class="ivu-modal-footer">
      <Button type="primary" @click="visible=false">确定</Button>
    </div>
  </Modal>
</template>

<script>
import uploadNew from "@/components/commons/uploadNew";
export default {
  components: {
    uploadNew,
  },
  props: [],
  data() {
    return {
      visible: false,
    };
  },
  created() {},
  methods: {
    open() {
      this.visible = true;
    },
  },

};
</script>
<style lang="scss" scoped>
.my-modal /deep/ {
  text-align: center;
  .ivu-modal-body {
    padding-top: 50px;
    padding-bottom: 90px;
  }
  .title-text {
    margin-top: 23px;
    font-size: 16px;
    color: #3C464F;
    font-weight: bold;
  }
  .info-text {
    font-size: 14px;
    color: #727C8E;
  }
  .info-text-desc {
    font-size: 14px;
    color: #F59045;
  }
  .ivu-btn {
    padding: 0 32px;
  }
}
</style>
